import { SiteInfo, SiteSocial } from '@/types/_site';
import clsx from 'clsx';
import BlurImage from '../BlurImage';

interface BioHeaderElementProps {
    site: SiteInfo;
    viewMode?: boolean;
}

export default function BioHeaderElement({ site, viewMode }: BioHeaderElementProps) {
    const alignment = site.appearance?.headerAlignment === 'center' ? 'items-center' : 'items-start';
    return (
        <div className="w-full">
            <div className={clsx("flex flex-col justify-center space-y-4 text-gray-800", alignment, alignment == 'items-center' ? 'px-6 text-center' : 'px-0')}>
                {
                site.logo && !site.appearance?.hideLogo && 
                <div className={clsx("inline-block w-24 h-24 overflow-hidden align-middle rounded-full", viewMode ? "md:w-36 md:h-36" : "")}>
                    <BlurImage
                        alt={site?.name!}
                        height={200}
                        src={site?.logo!}
                        blurDataURL={site?.logoBlurHash}
                        width={200}
                        objectFit="cover"
                    />
                </div>}
                <h1
                    className={clsx("text-3xl tracking-normal leading-7 text-black font-DMSerifDisplay font-semibold animated fadeInUp", viewMode ? "md:text-4xl" : "")}
                    >{site.name}
                </h1>
                <p
                    className={
                        clsx(
                            "flex w-full font-medium font-cal transition-colors duration-200 sm:w-auto animated fadeInUp text-md",
                            viewMode ? alignment == "items-center" ? "px-3 md:px-20" : "md:text-lg" : "", alignment, alignment == "items-center" ? "text-center justify-center" : "justify-start text-left"
                        )
                    } dangerouslySetInnerHTML={{__html: site.description}}>
                    
                </p>
                <div className="flex flex-row flex-wrap justify-center gap-6">
                    {site['socials'] && site['socials'].map((value: SiteSocial, index: number) => {
                        return <a key={index} href={`${value['prefix']}${value['value']}`}
                            target="_blank"
                            className="w-6 text-indigo-700 transition duration-300 rounded-full hover:scale-125" rel="noreferrer">
                            <span className="h-4">
                                <img height="32" width="32"
                                    src={value['id'] === 'email' ? 
                                        `https://unpkg.com/simple-icons@v4/icons/gmail.svg` :
                                        `https://unpkg.com/simple-icons@v4/icons/${value['id']}.svg`}
                                    alt={value['id']} />
                            </span>
                        </a>
                    })}
                </div>
            </div>
        </div>
    )
}